__turbopack_context__.v({
  "acheivement": "Home-module__vTASJq__acheivement",
  "acheivermore": "Home-module__vTASJq__acheivermore",
  "acheivername": "Home-module__vTASJq__acheivername",
  "acheiverrank": "Home-module__vTASJq__acheiverrank",
  "acheiverrankhome": "Home-module__vTASJq__acheiverrankhome",
  "active": "Home-module__vTASJq__active",
  "active1": "Home-module__vTASJq__active1",
  "active2": "Home-module__vTASJq__active2",
  "active3": "Home-module__vTASJq__active3",
  "active5": "Home-module__vTASJq__active5",
  "active6": "Home-module__vTASJq__active6",
  "activeSlide": "Home-module__vTASJq__activeSlide",
  "alerttext": "Home-module__vTASJq__alerttext",
  "announcement": "Home-module__vTASJq__announcement",
  "announcementlink": "Home-module__vTASJq__announcementlink",
  "attractStage": "Home-module__vTASJq__attractStage",
  "bestbg": "Home-module__vTASJq__bestbg",
  "bg": "Home-module__vTASJq__bg",
  "bground": "Home-module__vTASJq__bground",
  "blogid": "Home-module__vTASJq__blogid",
  "bottomLeft": "Home-module__vTASJq__bottomLeft",
  "bottomLeftcircle": "Home-module__vTASJq__bottomLeftcircle",
  "bottomRight": "Home-module__vTASJq__bottomRight",
  "bottomRightcircle": "Home-module__vTASJq__bottomRightcircle",
  "branchtitle": "Home-module__vTASJq__branchtitle",
  "btnArrow": "Home-module__vTASJq__btnArrow",
  "btnText": "Home-module__vTASJq__btnText",
  "captcha": "Home-module__vTASJq__captcha",
  "card": "Home-module__vTASJq__card",
  "cardBox": "Home-module__vTASJq__cardBox",
  "carouselarrowleft": "Home-module__vTASJq__carouselarrowleft",
  "carouselarrowright": "Home-module__vTASJq__carouselarrowright",
  "carouselnavwrapper": "Home-module__vTASJq__carouselnavwrapper",
  "carouseltarget": "Home-module__vTASJq__carouseltarget",
  "centerContent": "Home-module__vTASJq__centerContent",
  "centerImage": "Home-module__vTASJq__centerImage",
  "circleItem": "Home-module__vTASJq__circleItem",
  "circleItemText": "Home-module__vTASJq__circleItemText",
  "circleWrap": "Home-module__vTASJq__circleWrap",
  "circletopLeft": "Home-module__vTASJq__circletopLeft",
  "circlevideo": "Home-module__vTASJq__circlevideo",
  "cityid": "Home-module__vTASJq__cityid",
  "civillogo": "Home-module__vTASJq__civillogo",
  "civilserviveheading": "Home-module__vTASJq__civilserviveheading",
  "controls": "Home-module__vTASJq__controls",
  "couresesimg1": "Home-module__vTASJq__couresesimg1",
  "courseList": "Home-module__vTASJq__courseList",
  "courseknowmore": "Home-module__vTASJq__courseknowmore",
  "courseshover": "Home-module__vTASJq__courseshover",
  "courseshover2": "Home-module__vTASJq__courseshover2",
  "courseshover3": "Home-module__vTASJq__courseshover3",
  "coursesimg": "Home-module__vTASJq__coursesimg",
  "dot": "Home-module__vTASJq__dot",
  "downArrow": "Home-module__vTASJq__downArrow",
  "event-title": "Home-module__vTASJq__event-title",
  "eventbox": "Home-module__vTASJq__eventbox",
  "eventbutton": "Home-module__vTASJq__eventbutton",
  "eventsRoot": "Home-module__vTASJq__eventsRoot",
  "eventsRow": "Home-module__vTASJq__eventsRow",
  "facultyborder3": "Home-module__vTASJq__facultyborder3",
  "feature": "Home-module__vTASJq__feature",
  "feature1": "Home-module__vTASJq__feature1",
  "floatHero": "Home-module__vTASJq__floatHero",
  "fonthover": "Home-module__vTASJq__fonthover",
  "formstar": "Home-module__vTASJq__formstar",
  "haloOne": "Home-module__vTASJq__haloOne",
  "haloTwo": "Home-module__vTASJq__haloTwo",
  "headerbuttonalink": "Home-module__vTASJq__headerbuttonalink",
  "heading3d": "Home-module__vTASJq__heading3d",
  "headingWrapper": "Home-module__vTASJq__headingWrapper",
  "headingWrapper1": "Home-module__vTASJq__headingWrapper1",
  "icon": "Home-module__vTASJq__icon",
  "imageWrapper": "Home-module__vTASJq__imageWrapper",
  "indiamap": "Home-module__vTASJq__indiamap",
  "item": "Home-module__vTASJq__item",
  "itemRed": "Home-module__vTASJq__itemRed",
  "left": "Home-module__vTASJq__left",
  "leftBox": "Home-module__vTASJq__leftBox",
  "leftBox1": "Home-module__vTASJq__leftBox1",
  "leftcarousel": "Home-module__vTASJq__leftcarousel",
  "line": "Home-module__vTASJq__line",
  "locationid": "Home-module__vTASJq__locationid",
  "lookingForOnlineClass": "Home-module__vTASJq__lookingForOnlineClass",
  "lottiescroll": "Home-module__vTASJq__lottiescroll",
  "marquee": "Home-module__vTASJq__marquee",
  "mdeal": "Home-module__vTASJq__mdeal",
  "mentoring": "Home-module__vTASJq__mentoring",
  "navBtn": "Home-module__vTASJq__navBtn",
  "navarrow": "Home-module__vTASJq__navarrow",
  "navdots": "Home-module__vTASJq__navdots",
  "newachievernumber": "Home-module__vTASJq__newachievernumber",
  "newachievernumber1": "Home-module__vTASJq__newachievernumber1",
  "newbtn": "Home-module__vTASJq__newbtn",
  "newbutton": "Home-module__vTASJq__newbutton",
  "nexticon": "Home-module__vTASJq__nexticon",
  "normalbutton": "Home-module__vTASJq__normalbutton",
  "normalbutton1": "Home-module__vTASJq__normalbutton1",
  "orbitReverse": "Home-module__vTASJq__orbitReverse",
  "orbitSlow": "Home-module__vTASJq__orbitSlow",
  "ourachievementcontent": "Home-module__vTASJq__ourachievementcontent",
  "perspective3d": "Home-module__vTASJq__perspective3d",
  "playSize": "Home-module__vTASJq__playSize",
  "previcon": "Home-module__vTASJq__previcon",
  "queueSlide": "Home-module__vTASJq__queueSlide",
  "redbg": "Home-module__vTASJq__redbg",
  "right": "Home-module__vTASJq__right",
  "rightBox": "Home-module__vTASJq__rightBox",
  "rightBox1": "Home-module__vTASJq__rightBox1",
  "rightcarousel": "Home-module__vTASJq__rightcarousel",
  "roadmapStart": "Home-module__vTASJq__roadmapStart",
  "scrollcontent": "Home-module__vTASJq__scrollcontent",
  "scrolldiv": "Home-module__vTASJq__scrolldiv",
  "scrollparent": "Home-module__vTASJq__scrollparent",
  "sectionsubtitle": "Home-module__vTASJq__sectionsubtitle",
  "sectiontext": "Home-module__vTASJq__sectiontext",
  "sectiontitle": "Home-module__vTASJq__sectiontitle",
  "sectiontitle1": "Home-module__vTASJq__sectiontitle1",
  "shift-left": "Home-module__vTASJq__shift-left",
  "slide": "Home-module__vTASJq__slide",
  "slideImage": "Home-module__vTASJq__slideImage",
  "slidebutton": "Home-module__vTASJq__slidebutton",
  "slidedownArrow": "Home-module__vTASJq__slidedownArrow",
  "sliderTrack": "Home-module__vTASJq__sliderTrack",
  "sliderWrapper": "Home-module__vTASJq__sliderWrapper",
  "studentimage": "Home-module__vTASJq__studentimage",
  "studentvideo": "Home-module__vTASJq__studentvideo",
  "tabButton": "Home-module__vTASJq__tabButton",
  "tabRow": "Home-module__vTASJq__tabRow",
  "tabredButton": "Home-module__vTASJq__tabredButton",
  "title": "Home-module__vTASJq__title",
  "topLeft": "Home-module__vTASJq__topLeft",
  "topLeftcircle": "Home-module__vTASJq__topLeftcircle",
  "topRight": "Home-module__vTASJq__topRight",
  "topRightcircle": "Home-module__vTASJq__topRightcircle",
  "upArrow": "Home-module__vTASJq__upArrow",
  "videoPortrait": "Home-module__vTASJq__videoPortrait",
  "viewbutton": "Home-module__vTASJq__viewbutton",
  "viewbuttonalink": "Home-module__vTASJq__viewbuttonalink",
  "whychooseBox": "Home-module__vTASJq__whychooseBox",
  "whyshankarcont": "Home-module__vTASJq__whyshankarcont",
  "whyshankarcontnew": "Home-module__vTASJq__whyshankarcontnew",
  "wrapper": "Home-module__vTASJq__wrapper",
});
